import {ChangeDetectionStrategy, Component, ElementRef, ViewChild} from '@angular/core';


@Component({
  selector: 'demo-app',
  templateUrl: './app.component.html',
  styles: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  public cuePoints: any;
  public source: any;
  public config;
  public plugins;

  @ViewChild('templ') templ: ElementRef;

  constructor() {

    this.config = {
      // mode: PlayerMode.SMART_MODE,
    };

    this.plugins = {

      
    };

    this.source  = {
      poster: '',
      sources: [
        {
          src: 'https://cdn.runway.moda/eleks-prod-runway-video-storage/designer/null/videos/f7b015d68923172e157a2d533a659394520ebb55c82578a3e196acea3fedf979.mp4'
        },
      ],
    };
  }

  public handleClick(event): void {
    event.stopPropagation();
    alert('Clicked!!!');
  }

  public cuePointShow(cuePoint: any): void {
    console.log(cuePoint);
  }

  public handleCuePoint(event: any): void {
    console.log(event.detail.cuePoint);
  }
}
